import React from 'react';
import { AlertTriangle, RefreshCw, Home } from 'lucide-react';

const ErrorPage = ({ 
  title = "Something went wrong",
  message = "We've encountered an error. Please try again or contact support if the problem persists.",
  errorCode = "500",
  onRetry = () => window.location.reload(),
  onHome = () => window.location.href = "/userdashboard/dashboardhome"
}) => {
  return (
    <div className="error-new-cmpt-container">
      <div className="error-new-cmpt-card">
        <div className="error-new-cmpt-icon-container">
          <AlertTriangle className="error-new-cmpt-icon" />
        </div>
        <h1 className="error-new-cmpt-title">{title}</h1>
        <div className="error-new-cmpt-code">Error {errorCode}</div>
        <p className="error-new-cmpt-message">{message}</p>
        <div className="error-new-cmpt-actions">
          <button 
            className="error-new-cmpt-button error-new-cmpt-button-retry" 
            onClick={onRetry}
          >
            <RefreshCw className="error-new-cmpt-button-icon" />
            Try Again
          </button>
          <button 
            className="error-new-cmpt-button error-new-cmpt-button-home" 
            onClick={onHome}
          >
            <Home className="error-new-cmpt-button-icon" />
            Go Home
          </button>
        </div>
      </div>

      <style jsx>{`
        .error-new-cmpt-container {
          display: flex;
          align-items: center;
          justify-content: center;
          min-height: 100vh;
          padding: 20px;
          background-color: #f9fafb;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }

        .error-new-cmpt-card {
          width: 100%;
          max-width: 460px;
          padding: 32px;
          background-color: white;
          border-radius: 8px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          text-align: center;
        }

        .error-new-cmpt-icon-container {
          display: flex;
          justify-content: center;
          margin-bottom: 24px;
        }

        .error-new-cmpt-icon {
          width: 48px;
          height: 48px;
          color: #ef4444;
          stroke-width: 1.5;
        }

        .error-new-cmpt-title {
          margin: 0 0 8px;
          font-size: 24px;
          font-weight: 600;
          color: #111827;
        }

        .error-new-cmpt-code {
          font-size: 14px;
          font-weight: 500;
          color: #6b7280;
          margin-bottom: 16px;
        }

        .error-new-cmpt-message {
          margin: 0 0 32px;
          color: #4b5563;
          font-size: 16px;
          line-height: 1.5;
        }

        .error-new-cmpt-actions {
          display: flex;
          gap: 12px;
          justify-content: center;
        }

        .error-new-cmpt-button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 10px 16px;
          border-radius: 6px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.2s;
          border: none;
        }

        .error-new-cmpt-button-icon {
          width: 16px;
          height: 16px;
        }

        .error-new-cmpt-button-retry {
          background-color: #2563eb;
          color: white;
        }

        .error-new-cmpt-button-retry:hover {
          background-color: #1d4ed8;
        }

        .error-new-cmpt-button-home {
          background-color: #f3f4f6;
          color: #374151;
        }

        .error-new-cmpt-button-home:hover {
          background-color: #e5e7eb;
        }

        @media (max-width: 640px) {
          .error-new-cmpt-card {
            padding: 24px;
          }
          
          .error-new-cmpt-actions {
            flex-direction: column;
          }
          
          .error-new-cmpt-button {
            width: 100%;
          }
        }
      `}</style>
    </div>
  );
};

export default ErrorPage;